import React from 'react'
import cx from 'classnames'
import MuiCheckbox from '@material-ui/core/Checkbox/Checkbox'
import withStyles from '@material-ui/core/styles/withStyles'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import MuiTableRow from '@material-ui/core/TableRow'
import MuiTableCell from '@material-ui/core/TableCell'
import TealToolTip from 'components/TealToolTip'

export const DISABLED = 0
export const NONE_SELECTED = 1
export const SOME_SELECTED = 2
export const ALL_SELECTED = 3
export const EMPTY_SELECTION = 4

const Checkbox = withStyles({
  root: {
    color: '#6288a5'
  }
})(props => <MuiCheckbox color='default' {...props} />)

const popoverMessage = (state, selectedDealName) => {
  switch (state) {
    case DISABLED: return 'Select at least one deal first to be able to select all deals of the same deal type.'
    case NONE_SELECTED: return `Select all ${selectedDealName} deals on this page`
    case SOME_SELECTED: return `Select all ${selectedDealName} deals on this page`
    case ALL_SELECTED: return 'Deselect all deals on this page'
    case EMPTY_SELECTION: return 'Nothing to select on this page'
    default: return ''
  }
}

const HeaderTableCell = ({ children }) => (
  <MuiTableCell classes={{ root: 'b' }}>{children}</MuiTableCell>
)

export default ({ onSelect, showDealType, state, selectedDealName }) => (
  <MuiTableRow>
    <MuiTableCell padding='checkbox' classes={{ root: 'dn-l dn-d' }}>
      <HeaderCheckbox {...{ state, selectedDealName, onSelect }} />
    </MuiTableCell>
    <HeaderTableCell>Deal</HeaderTableCell>
    <HeaderTableCell>Date</HeaderTableCell>
    {showDealType && <HeaderTableCell><span className='no-wrap w-max-content'>Deal type</span></HeaderTableCell>}
    <HeaderTableCell>Market</HeaderTableCell>
    <MuiTableCell padding='checkbox' classes={{ root: 'dn-t' }}>
      <HeaderCheckbox {...{ state, selectedDealName, onSelect }} />
    </MuiTableCell>
  </MuiTableRow>
)

const HeaderCheckbox = ({ state, selectedDealName, onSelect, placement = 'top-end' }) => (
  <TealToolTip arrow title={popoverMessage(state, selectedDealName)} {...{ placement }}>
    <span>
      <Checkbox
        checkedIcon={
          <CheckBoxIcon
            className={cx({
              'dark-cyan': state === ALL_SELECTED,
              'cadet-blue': state !== ALL_SELECTED
            })}
          />
        }
        checked={state === ALL_SELECTED || state === SOME_SELECTED}
        disabled={state === DISABLED || state === EMPTY_SELECTION}
        onChange={onSelect}
        value='checkedA'
      />
    </span>
  </TealToolTip>
)
